import {Form, InputNumber, Modal,  App,    Row, Col, Input, Space   } from 'antd'
import React, { useEffect, useState } from 'react'
import classes from './invoice.module.css'
import Icon from '../../cpn/Icon';
import { useKaipiaodanAddMutation, useKPSQaddtijiaoMutation } from '../../store/DianShangYeWuApi';
import OCRTextArea from '../../cpn/OCRTextArea';
import ClientSelect from '../../system/client/ClientSelect';  
import UploadPic from '../../cpn/UploadPic';
import dayjs from 'dayjs';
import DocumentRule from '../../cpn/DocumentRule';
import Asterisk from '../../cpn/Asterisk';
import InvoiceNodeAdd from './InvoiceNodeAdd';
import InvoiceTypeSelect from '../../system/invoice/invoiceType/InvoiceTypeSelect';
import ClientInvoiceSelect from '../../system/client/ClientInvoiceSelect';
function InvoiceAddReportEdit(props) {
    const { message } = App.useApp();
    const [open,setOpen] = useState(false);
    const [info,setInfo] = useState({
        'kpsq_price': props.dsbzd_kh_id,//保存团队客户id
        'kpsq_uid': '',
        'kpsq_uname': '',
        'kpsq_content': '',
        'kpsq_bzd_id': '',
        'kpsq_qy_id': '',
        'kpsq_qy_name': '',
        'kpsq_kh_id': '',
        'kpsq_kh_name': '',
        'kpsq_type_id': props.dsbzd_dscp_id,//保存团队客户类型id
        'kpsq_type_name': props.dsbzd_dscp_name,//保存团队客户类型名称
        'kpsq_amount': '',
        'kpsq_bzd_xuhao': '',
        'kpsq_bzd_name': '',
        'kpsq_date': props.dsbzd_date ? dayjs(props.dsbzd_date) : undefined,
        'kpsq_bzd_date_end': '',
        'kpsq_num': props.dsbzd_kh_name,//保存团队客户名称
        'kpsq_name': '',
        'kpsq_bzd_date': '',
        'kpsq_khyhzh_id': '',
        'kpsq_khyhzh_name': '',
        'kpsq_image_name': '',
        'kpsq_image_file': '',
        'kpsq_bm_id': props.dsbzd_bm_id,
        'kpsq_bm_name': props.dsbzd_bm_name,
        'kpsq_state': '1'
    })
    const [form] = Form.useForm();
    const [add] = useKaipiaodanAddMutation();
    useEffect(() => {
        // 确保kpsq_date有默认值，同时更新其他相关字段
        if (!info.kpsq_date || props.dsbzd_date !== info.kpsq_date || props.dsbzd_date_end !== info.kpsq_date_end) {
            setInfo(prevState => ({
                ...prevState,
                kpsq_date: props.dsbzd_date || new Date().toISOString().split('T')[0],
                kpsq_date_end: props.dsbzd_date_end || new Date().toISOString().split('T')[0],
                kpsq_bzd_name: props.dsbzd_name || prevState.kpsq_bzd_name,
                kpsq_bzd_danhao: props.dsbzd_danhao || prevState.kpsq_bzd_danhao,
                kpsq_bzd_id: props.dsbzd_id || prevState.kpsq_bzd_id
            }))
        }
    }, [props, info.kpsq_date, info.kpsq_date_end])

    // 当Modal打开时设置表单值
    useEffect(() => {
        if (open) {
            if (props.dsbzd_date && props.dsbzd_date_end) {
                form.setFieldsValue({
                    kpsq_bzd_name: props.dsbzd_danhao + ' ' + props.dsbzd_name,
                })
            }
            // 设置表单字段的初始值
            form.setFieldsValue({
                kpsq_price: props.dsbzd_kh_id,
                kpsq_num: '',
                kpsq_amount: ''
            })
        }
    }, [open, props, form])

    //提交
    const [addtijiao] = useKPSQaddtijiaoMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    return (
        <>
            <Icon type='add' onClick={() => {setOpen(true)}} />
            <Modal
                open={open} 
                onCancel={() => {setOpen(false)}}
                width={1330}
                form={form}
                footer={null}
            >
                <Form
                    form={form}
                    className={classes.form}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                    initialValues={{
                        kpsq_date: props.dsbzd_date ? dayjs(props.dsbzd_date) : undefined,
                        kpsq_bm_id: props.dsbzd_bm_id ? props.dsbzd_bm_id : undefined,
                        kpsq_bm_name: props.dsbzd_bm_name ? props.dsbzd_bm_name : undefined,
                    }}
                >
                     <Row style={{width:"1280px"}}>
                        <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #FF6600',borderLeft:'3px solid #FF6600'}}></Col>
                        <Col span={16} className={classes.row_top_middle} style={{color:'#FF6600',borderTop:'3px solid #FF6600'}}>开票申请</Col>
                        <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #FF6600',borderRight:'3px solid #FF6600'}}></Col>
                         {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #FF6600',color:'#FF6600'}}> 团队名称</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            {props.dsbzd_name}
                        </Col>  
                        <Col span={2} className={classes.col_top_label} ><Asterisk color='red'/> 开票金额</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            <Form.Item 
                                name='kpsq_amount'
                                noStyle
                            >
                                <InputNumber 
                                    placeholder='请输入金额' 
                                    onChange={(value) => {
                                        setInfo(prevState => ({ ...prevState, kpsq_amount: value }))
                                    }}
                                    style={{ width: '310px' }}
                                    min={0.01}
                                />
                            </Form.Item>
                        </Col>  
                        <Col span={2}  className={classes.col_top_label} ><Asterisk color='red'/> 部门</Col>
                        <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #FF6600'}}>
                            {props.dsbzd_bm_name}
                        </Col> 
                        {/* 第二行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF6600'}}><Asterisk color='red'/> 客户</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <ClientSelect
                                name='kpsq_kh_name'
                                placeholder='请选择客户'
                                onChange={(value,label) => {
                                    setInfo(prevState => ({ ...prevState, kpsq_kh_id: value, kpsq_kh_name: label }))
                                }}
                                style={{width: '230px'}}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                qy_id={props.qy_id}
                                yh_id={props.yh_id}
                                defaultId={info.kpsq_kh_id}
                                wrapperCol={{span:24}}
                                clientAdd={true}
                            />
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 开票信息</Col>
                        <Col span={14}  className={classes.col_middle_input} style={{borderRight:'3px solid #FF6600'}}>
                           <ClientInvoiceSelect
                                name='kpsq_kh_khkpxx'
                                placeholder='请选开票信息'
                                onChange={(value,label) => {
                                    setInfo(prevState => ({ ...prevState, kpsq_khfpxx_id: value, kpsq_khfpxx_name: label }))
                                }}
                                style={{width: '100%'}}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                qy_id={props.qy_id}
                                yh_id={props.yh_id}
                                defaultId={info.kpsq_khfpxx_id}
                                wrapperCol={{span:24}}
                                kh_id={info.kpsq_kh_id}
                            />
                        </Col>
                        {/* 第二行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF6600'}}><Asterisk color='red'/>开票项目</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <Form.Item name='kpsq_name' noStyle>
                               <Input 
                                    placeholder='请输入开票项目' 
                                    value={info.kpsq_name}
                                    style={{ width: '100%' }}
                                    onChange={(e) => {
                                         setInfo(prevState => ({ ...prevState, kpsq_name: e.target.value }))
                                    }}
                               />
                            </Form.Item>
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 发票类型</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{display:'flex',alignItems:'center',justifyContent:'left',}}>
                            <InvoiceTypeSelect
                                name='kpsq_type_id'
                                placeholder='请选择发票类型'
                                onChange={(value,label) => {
                                    setInfo(prevState => ({ ...prevState, kpsq_type_id: value, kpsq_type_name: label }))
                                }}
                                style={{width: '310px'}}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                qy_id={props.qy_id}
                            />
                        </Col> 
                        <Col span={2} className={classes.col_middle_label}>备注 </Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{display:'flex',alignItems:'center',justifyContent:'left',borderRight:'3px solid #FF6600'}}>
                        <Form.Item name='kpsq_content' noStyle>
                                <OCRTextArea
                                    value={info.kpsq_content}
                                    onChange={(e) => {
                                        setInfo(prevState => ({ ...prevState, kpsq_content: e.target.value }))
                                    }}
                                    language="chi_sim"
                                />
                            </Form.Item>
                        </Col> 
                        
                        {/* 第四行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF6600'}}>附件</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                        <UploadPic
                                name='kpsq_image'
                                onChange={(e,f) => {
                                    setInfo(prevState => ({ ...prevState, kpsq_image_file: e, kpsq_image_name: f }))
                                }}
                                maxCount={5}
                                style={{ width: '100%' }}
                                formStyle={{marginBottom: 0,width: '100%'}}
                            />
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}>编号 / 状态</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{display:'flex',alignItems:'center',justifyContent:'left',}}>
                            
                        </Col> 
                        <Col span={2} className={classes.col_middle_label}>发票下载 </Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{display:'flex',alignItems:'center',justifyContent:'left',borderRight:'3px solid #FF6600'}}>
                            
                        </Col> 
                        {/* 第五行 */}
                      
                        <Col span={24} className={classes.bottom_row}>
                            <InvoiceNodeAdd qy_id={props.qy_id} user_id={props.yh_id} yh_name={props.yh_name} kpsq_state={info.kpsq_state}  />
                        </Col>                                           
                    </Row>   
                    <Row>
                        <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                            <DocumentRule/>
                            <Space size={20}>
                                <Icon 
                                    type='save' 
                                    title='保存不提交'
                                    onClick={() => {
                                        if(info.kpsq_name === ''){
                                            message.error('请输入开票项目');
                                            return;
                                        }
                                        if(info.kpsq_amount === ''){
                                            message.error('请输入开票金额');
                                            return;
                                        }
                                        if(info.kpsq_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        } 
                                        if(info.kpsq_khfpxx_id === ''){
                                            message.error('请选择开票信息');
                                            return;
                                        }  
                                        if(info.kpsq_type_id === ''){
                                            message.error('请选择发票类型');
                                            return;
                                        }    
                                                                        
                                        add({
                                            'kpsq_qy_id': props.qy_id,  
                                            'kpsq_qy_name': props.qy_name,
                                            'kpsq_type_id': info.kpsq_type_id,
                                            'kpsq_type_name': info.kpsq_type_name,
                                            'kpsq_bzd_xuhao': '',
                                            'kpsq_price': props.dsbzd_kh_id,
                                            'kpsq_kh_id': info.kpsq_kh_id,
                                            'kpsq_kh_name': info.kpsq_kh_name,
                                            'kpsq_amount': info.kpsq_amount,
                                            'kpsq_num': '',
                                            'kpsq_content': info.kpsq_content,
                                            'kpsq_bzd_id': props.dsbzd_id,
                                            'kpsq_bzd_name': props.dsbzd_name,
                                            'kpsq_uid': props.yh_id,
                                            'kpsq_uname': props.yh_name,
                                            'kpsq_image_name': info.kpsq_image_name?info.kpsq_image_name:'',
                                            'kpsq_image_file': info.kpsq_image_file?info.kpsq_image_file:'',
                                            'kpsq_bm_id': props.dsbzd_bm_id,
                                            'kpsq_bm_name': props.dsbzd_bm_name,
                                            'kpsq_khfpxx_id': info.kpsq_khfpxx_id,
                                            'kpsq_khfpxx_name': info.kpsq_khfpxx_name,
                                            'kpsq_name': info.kpsq_name,
                                            'kpsq_state': '1',
                                            'kpsq_bzd_date_end': props.dsbzd_date_end,
                                            'kpsq_date': '',
                                            'kpsq_bzd_date': props.dsbzd_date,
                                            'kpsq_ddsr_id': props.dsbzd_id,
                                            'spdd_sp_id': '14',
                                            'spdd_sp_name': '财务管理',
                                            'spdd_spgg_id': '22',
                                            'spdd_spgg_name': '开票申请',
                                            'spdd_spgg_price': '0.1',
                                            'spdd_state': '支出'
                                        }).then(res => {
                                            if(res.data.Status==='success'){
                                                setOpen(false);
                                                message.success('保存成功');
                                                form.resetFields();  
                                            }else{
                                                message.error('保存失败！' + res.data.Message);
                                            }
                                        })  
                                        
                                           
                                    }} 
                                />
                                <Icon 
                                    type='reset' 
                                    onClick={() => {
                                        form.resetFields();
                                        setInfo(prevState => ({ 
                                            ...prevState, 
                                            kpsq_price: props.dsbzd_kh_id, 
                                            kpsq_num: '', 
                                            kpsq_amount: 0.01, 
                                            kpsq_content: '',                             
                                            kpsq_type_id: '', 
                                            kpsq_type_name: '', 
                                            kpsq_kh_id: '', 
                                            kpsq_kh_name: '', 
                                            kpsq_qyyhzh_id: '', 
                                            kpsq_qyyhzh_name: '',
                                            kpsq_bm_id: '',
                                            kpsq_bm_name: '',
                                            kpsq_image_name: '',
                                            kpsq_image_file: '',
                                            kpsq_zflx: ''
                                        }))
                                    }} 
                                />
                                <Icon
                                    type='submit'
                                    title='提交'
                                    disabled={isSubmitting}
                                    style={isSubmitting ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                    onClick={() => {
                                        // 如果正在提交中，直接返回
                                        if (isSubmitting) {
                                            return;
                                        }
                                        
                                        // 先进行验证
                                        if(info.kpsq_name === ''){
                                            message.error('请输入开票项目');
                                            return;
                                        }
                                        if(info.kpsq_amount === ''){
                                            message.error('请输入开票金额');
                                            return;
                                        }
                                        if(info.kpsq_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        } 
                                        if(info.kpsq_khfpxx_id === ''){
                                            message.error('请选择开票信息');
                                            return;
                                        }  
                                        if(info.kpsq_type_id === ''){
                                            message.error('请选择发票类型');
                                            return;
                                        }              
                                        
                                        // 验证通过后，设置提交状态
                                        setIsSubmitting(true);
                                        addtijiao({
                                            'kpsq_type_id': info.kpsq_type_id,
                                            'kpsq_type_name': info.kpsq_type_name,
                                            'kpsq_amount': info.kpsq_amount,
                                            'kpsq_qy_id': props.qy_id,
                                            'kpsq_qy_name': props.qy_name,
                                            'kpsq_num': '1',
                                            'kpsq_uid': props.yh_id,
                                            'kpsq_uname': props.yh_name,
                                            'kpsq_name': info.kpsq_name,
                                            'kpsq_date': info.kpsq_date,
                                            'kpsq_kh_id': info.kpsq_kh_id,
                                            'kpsq_kh_name': info.kpsq_kh_name,
                                            'kpsq_price': props.dsbzd_kh_id,
                                            'kpsq_content': info.kpsq_content,
                                            'kpsq_bzd_id': props.dsbzd_id,
                                            'kpsq_bzd_name': props.dsbzd_name,
                                            'kpsq_bzd_date': props.dsbzd_date,
                                            'kpsq_bzd_xuhao': '',
                                            'kpsq_bzd_date_end': props.dsbzd_date_end,
                                            'kpsq_khfpxx_id': info.kpsq_khfpxx_id,
                                            'kpsq_khfpxx_name': info.kpsq_khfpxx_name,
                                            'kpsq_bm_id': props.dsbzd_bm_id,
                                            'kpsq_bm_name': props.dsbzd_bm_name,
                                            'kpsq_image_name': info.kpsq_image_name?info.kpsq_image_name:'',
                                            'kpsq_image_file': info.kpsq_image_file?info.kpsq_image_file:'',
                                            'kpsq_ddsr_id': props.dsbzd_id,
                                            'kpsq_state':'2'
                                        }).then(res => {
                                            if(res.data.Status==='success'){
                                                message.success('提交成功');
                                                setIsSubmitting(false);     
                                                setOpen(false);                                       
                                                form.resetFields();  
                                            }else{
                                                message.error('提交失败！' + res.data.Message);
                                            }
                                        })     
                                    }}
                                /> 
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </Modal>

        </>
    )
}

export default InvoiceAddReportEdit